"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PromoModal = require("./PromoModal");
Object.keys(_PromoModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PromoModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PromoModal[key];
    }
  });
});